import React from 'react';
import Select from 'antd/es/select';

import { BaseInputProps, DescriptionFormItem } from './shared';

const Option = Select.Option;

interface MultiSelectInputProps extends Omit<BaseInputProps, 'placeholder'> {
    placeholder?: string[];
    options?: string[];
}
export const MultiSelectInput = ({
    label,
    name,
    rules,
    description = '',
    placeholder,
    options,
}: MultiSelectInputProps) => {
    return (
        <DescriptionFormItem label={label} name={name} rules={rules} description={description}>
            <Select mode="multiple" allowClear placeholder={placeholder}>
                {options?.length
                    ? options.map((option) => (
                          <Option key={option} value={option}>
                              {option}
                          </Option>
                      ))
                    : null}
            </Select>
        </DescriptionFormItem>
    );
};
